export const levelUp = (url) => url.substring(0, url.lastIndexOf('/')) || '/'
